// Create global object to use in case fail to get request_uuid from local storage
window.__requestUuidMemory = window.__requestUuidMemory || null;

// Function to populate hidden input fields from localStorage 
function populateInputs(formElement) {
    // checkbox - no if unchecked
    const checkbox = formElement.querySelector('input[type="checkbox"]');
    if (checkbox) {
        if (!checkbox.checked) {
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = checkbox.name;
            hiddenInput.value = "no";
            formElement.appendChild(hiddenInput);
            checkbox.disabled = true; // Prevent it from submitting nothing
        }
    }

    // hidden values
    const inputs = formElement.querySelectorAll('input[type="hidden"][name]');

    inputs.forEach((input) => {
        const hiddenValue = input.getAttribute('data-value');
        // console.log('hiddenValue:', hiddenValue);

        const utmData = JSON.parse(localStorage.getItem('utmData'));

        // Special handling for landing_page
        if (hiddenValue === 'landing_page') {
            try {
                if (utmData?.referrer) {
                    input.value = utmData.referrer;
                }
            } catch (e) {
                console.warn('Failed to parse utmData from localStorage:', e);
            }
        }

        // Special handling for device
        else if (hiddenValue === 'device') {

            const isMobile = /Mobi|Android/i.test(navigator.userAgent);
            input.value = isMobile ? 'mobile' : 'desktop';
        }

        // Special handling for ab_tests
        else if (hiddenValue === 'ab_tests') {

            if (window.igData) {
                try {
                    const experiments = window.igData?.user.getExperiments();
                    if (experiments.length > 0) {
                        var abtData = "";
                        experiments.forEach(experiment => {
                            try {
                                var abtVariant = window.igData?.user.getTestGroup(experiment.id);
                                abtData = abtData + experiment.name + " : " + abtVariant.name + "; ";
                            } catch (err) {
                                console.error("Error processing experiment:", err);
                            }
                        });
                        input.value = abtData;
                    }
                } catch (error) {
                    console.error("Error retrieving Intelligems experiments:", error);
                }
            } else {
                console.warn("Intelligems API not available");
            }
        }

        // Special handling for form_id
        else if (hiddenValue === 'form_id') {
            input.value = formElement.getAttribute('data-form-id');
        }

        // Special handling for request_uuid 
        else if (hiddenValue === "request_uuid") {
            let stored;

            try {
                stored = localStorage.getItem(hiddenValue);
            } catch (e) {
                console.warn('localStorage unavailable, using memory fallback');
            }

            // Fallback if nothing in storage
            if (!stored) {
                // Check in-memory variable first
                if (window.__requestUuidMemory) {
                    stored = window.__requestUuidMemory;
                } else {
                    // Generate new UUID
                    stored = self.crypto?.randomUUID ? crypto.randomUUID() :
                        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                            const r = Math.random() * 16 | 0;
                            const v = c === 'x' ? r : (r & 0x3 | 0x8);
                            return v.toString(16);
                        });
                    // Save in memory for this tab session
                    window.__requestUuidMemory = stored;
                }

                // Best-effort persist in localStorage
                try {
                    localStorage.setItem(hiddenValue, stored);
                } catch (e) {
                    // Ignore if storage blocked
                }
            }

            // console.log('stored:', stored);

            // Assign to the hidden field
            try {
                input.value = JSON.parse(stored); // if stored as JSON
            } catch {
                input.value = stored;
            }
        }

        // Otherwise, use localStorage value
        else {
            const stored = localStorage.getItem(hiddenValue);
            if (stored !== null) {
                try {
                    input.value = JSON.parse(stored); // if stored as JSON
                } catch {
                    input.value = stored; // fallback to raw string
                }
            }
        }
    });
}

// Stop polling after 5 seconds
setTimeout(() => clearInterval(interval), 5000);

// When submit form...
function formSubmitted(formElement) {
    if (formElement.querySelector('#recaptcha-score') != null) {
        formElement.querySelector(".form-submit").style.display = 'none'
        getRecaptchaAndSubmit(submitMultipleStepForm, formElement)
    } else {
        submitMultipleStepForm(formElement)
    }
    return false;
}

function submitMultipleStepForm(formElement) {
    populateInputs(formElement);

    // Store email, name, and pro status in local storage if available
    const userEmail = formElement.querySelector('input[name="Email"]')?.value || "";
    const userFirstName = formElement.querySelector('input[name="First Name"]')?.value || "";
    const userLastName = formElement.querySelector('input[name="Last Name"]')?.value || "";
    const userFullName = [userFirstName, userLastName].filter(Boolean).join(' ') || null;
    //const isPro = formElement.querySelector("input[value=\"i'm_a_pro\"]")?.checked || false;
    const isProInput = formElement.querySelector("input[value=\"i'm_a_pro\"]");
    let isPro;

    if (isProInput) {
        isPro = isProInput.checked; // true or false based on this form
    }
    // merge only the available values in localStorage
    const update = {};
    if (userEmail) update.userEmail = userEmail;
    if (userFirstName) update.userFirstName = userFirstName;
    if (userLastName) update.userLastName = userLastName;
    if (userFullName) update.userFullName = userFullName;
    if (typeof isPro !== "undefined") update.isPro = isPro;

    const stored = JSON.parse(localStorage.getItem('formData') || "{}");
    const formData = { ...stored, ...update };
    localStorage.setItem('formData', JSON.stringify(formData));

    // Determine current form and next form
    let formId = formElement.id;
    let sectionId = formElement.getAttribute('data-form-id');
    // console.log('sectionId:', sectionId);

    const form = document.querySelector(`#${formId}[data-form-id=${sectionId}]`);
    form.submit()
    // console.log('form:', form);

    // Hide current form
    if (form) form.style.display = 'none';

    // Manually map exact ID transitions
    const formFlowMap = {
        'lead-gen-step-1': 'lead-gen-step-2',
        'lead-gen-step-2': 'lead-gen-step-3',
        'lead-gen-step-3': 'lead-gen-step-calendly',
        // Add more steps if needed
    };

    const nextFormId = formFlowMap[formId];

    const nextFormSelector = `#${nextFormId}[data-form-id="${sectionId}"]`;
    const nextForm = nextFormId ? document.querySelector(nextFormSelector) : null;
    // console.log('next form:', nextForm);

    if (nextForm) {
        nextForm.style.display = 'block';
        if (nextFormId === 'lead-gen-step-calendly') {
            const { userEmail, userFullName, isPro } = JSON.parse(localStorage.getItem('formData') || "{}");
            // console.log('userEmail, userFullName, isPro:', userEmail, userFullName, isPro);
            renderCalendly(userEmail, userFullName, isPro);
        }
    }
}

// Calendly dynamic update logic
async function renderCalendly(userEmail, userFullName, isPro) {
    const url = await window.CalendlyUrl.getUrl({
        email: userEmail,
        name: userFullName,
        isPro: isPro
    });
    const container = document.querySelector('.calendly-embed-wrapper');
    console.log('container:', container, 'url:', url);
    if (!container) return;

    // Clear container
    container.innerHTML = '';

    // Inject Calendly script only once
    if (!document.querySelector('script[src*="calendly.com/assets/external/widget.js"]')) {
        const script = document.createElement('script');
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        document.head.appendChild(script);
    }

    // Wait until Calendly global is ready
    const interval = setInterval(() => {
        if (window.Calendly) {
            clearInterval(interval);
            Calendly.initInlineWidget({
                url,
                parentElement: container,
                prefill: {}
            });
        }
    }, 100);
}
